import { render, staticRenderFns } from "./ApprovalDetail.vue?vue&type=template&id=abe26e90&scoped=true&"
import script from "./ApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./ApprovalDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalDetail.vue?vue&type=style&index=0&id=abe26e90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe26e90",
  null
  
)

export default component.exports